// extracted by mini-css-extract-plugin
export default {"ClearText":"geQ6wBlwl4S4mWEbhUHa"};